<div class="upload-file">
  <h2 mat-dialog-title>Upload Document</h2>

  <mat-dialog-content>
    <div
      class="upload-file__dropzone"
      appDragAndDrop
      (fileDropped)="handleFileInput($event)"
      [matTooltip]="'Max file size: 25MB, Allowed formats: ' + allowedFormats"
      matTooltipPosition="above"
      matTooltipShowDelay="1000">
      <input
        class="upload-file__dropzone--input"
        type="file"
        #fileDropRef
        id="fileDropRef"
        [accept]="allowedFormats"
        (change)="handleFileInput($event.target)" />
      <span class="material-symbols-outlined upload-file__dropzone--upload-icon">cloud_upload</span>
      <span class="upload-file__dropzone--info">Drag and drop file here</span>
      <span class="upload-file__dropzone--file-name">{{ documentName || 'No file selected' }}</span>
      <button mat-stroked-button class="upload-file__dropzone--browse" for="fileDropRef">Browse for file</button>
    </div>

    <div [formGroup]="formGroup" class="upload-file__dropdowns">
      <mat-form-field>
        <mat-label>Choose Category</mat-label>
        <mat-select formControlName="category">
          @for (category of categories; track category.key) {
            <mat-option [value]="category.key">{{ category.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Choose Company</mat-label>
        <mat-select formControlName="companyId">
          @for (company of companies$ | async; track company.id) {
            <mat-option [value]="company.id">{{ company.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="upload-file__buttons">
    <button mat-stroked-button (click)="clear()">Clear</button>
    @if (isUploading) {
      <button mat-flat-button disabled>
        <mat-icon>
          <mat-spinner [diameter]="18" [strokeWidth]="2.2"></mat-spinner>
        </mat-icon>
        Uploading
      </button>
    } @else {
      <button mat-flat-button (click)="upload()">Upload</button>
    }
  </mat-dialog-actions>
</div>
